// removed by extract-text-webpack-plugin
module.exports = {"root":"_3dLYL","primary":"_1YvH8","secondary":"_6JJ0o","small":"_3zJyZ","medium":"_2qrUQ","large":"_15GK-","full":"_3VCHy","rounded":"_2v4Pb","content":"_3CV4w","loading":"eWg_z","spinnerWrapper":"_3Ug5r"};


//////////////////
// WEBPACK FOOTER
// ../source/components/Button/styles.css
// module id = 1252
// module chunks = 6 7 8 9 10 11 12 13 14 15 16